<template>
    <div v-if="visible" class="install-prompt">
        <div class="install-prompt-content">
            <div class="install-prompt-icon">
                <span class="material-symbols-outlined">download</span>
            </div>
            <div class="install-prompt-text">
                <p class="install-prompt-title">Install Brittany Palazzo</p>
                <p class="install-prompt-subtitle">Install this app on your device for quick access and offline use.</p>
            </div>
            <div class="install-prompt-actions">
                <button class="install-prompt-dismiss" @click="dismiss">Not now</button>
                <button class="install-prompt-accept" @click="install">Install</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { pwaStore, installPwa } from './PwaStore.js'

const visible = ref(false)
let deferredPrompt = null

function handleBeforeInstallPrompt(e) {
    e.preventDefault()
    deferredPrompt = e
    pwaStore.isInstallable = true
    pwaStore.deferredPrompt = e
    visible.value = true
}

function handleAppInstalled() {
    visible.value = false
    pwaStore.isInstallable = false
    pwaStore.isInstalled = true
}

async function install() {
    await installPwa()
    visible.value = false
}

function dismiss() {
    visible.value = false
}

onMounted(() => {
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
    window.addEventListener('appinstalled', handleAppInstalled)
})

onUnmounted(() => {
    window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
    window.removeEventListener('appinstalled', handleAppInstalled)
})
</script>

<style scoped>
.install-prompt {
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    max-width: 400px;
    width: calc(100% - 48px);
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 12px 32px rgba(52, 48, 43, 0.12);
    padding: 16px;
}

.install-prompt-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.install-prompt-icon {
    width: 48px;
    height: 48px;
    background: #f5ece5;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.install-prompt-icon .material-symbols-outlined {
    font-size: 24px;
    color: #775928;
}

.install-prompt-text {
    flex: 1;
    min-width: 0;
}

.install-prompt-title {
    font-size: 14px;
    font-weight: 600;
    color: #1e1b17;
    margin: 0;
}

.install-prompt-subtitle {
    font-size: 12px;
    color: #4e453a;
    margin: 2px 0 0 0;
}

.install-prompt-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.install-prompt-dismiss {
    background: none;
    border: none;
    color: #775928;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 8px;
}

.install-prompt-dismiss:hover {
    background: #f5ece5;
}

.install-prompt-accept {
    background: linear-gradient(135deg, #775928, #b08d57);
    color: #ffffff;
    border: none;
    padding: 8px 16px;
    border-radius: 9999px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

.install-prompt-accept:hover {
    opacity: 0.9;
}
</style>
